import React from 'react';
import "../printInvoice/PrintBillDesk.scss";
import moment from 'moment';

function PrintMinimalistic({
  printRef,
  receipt,
  patientName,
  mocPatientId,
  patientAge,
  patientGender,
  primaryConsultant,
  centerName,
  brandName,
  companyName
}: any) {

  return (
    <div className='print-billdesks-wrapper'
      id="printId"
      ref={printRef}
    >
      <section className='section-wrapper'>
        <div className='heading-1'>{brandName ? brandName : `Mumbai Oncocare Centre ${centerName}`}
        </div>
        <div className='heading-2'>{companyName ? companyName : "Cellcure Cancer Centre Private Limited"}</div>
      </section>
      <section className='section-2'>
        <section className='main-section-2'>
          <div className='subHeading-main'>Patient Name:&nbsp;<span className='subHeading2-main'>{patientName}</span></div>
          <div className='subHeading-main'>Patient ID: &nbsp;<span className='subHeading2-main'> {mocPatientId}</span></div>
          <div className='subHeading-main'>Age: &nbsp;<span className='subHeading2-main'>{patientAge}</span></div>
          <div className='subHeading-main'>Gender: &nbsp;<span className='subHeading2-main'>{patientGender}</span></div>
          <div className='subHeading-main'>Primary Consultant: &nbsp;<span className='subHeading2-main'>{primaryConsultant}</span></div>
        </section>
        <section className='main-section-2'>

          <div className='subHeading-main'>Receipt Date:&nbsp; <span className='subHeading2-main'>{receipt?.receiptDateTime ? moment(receipt?.receiptDateTime).format("DD-MM-YYYY") : ''}</span>	</div>
          <div className='subHeading-main'>Receipt Number:&nbsp;<span className='subHeading2-main'>{receipt?.mocReceiptId}{" "}
          </span>
          </div>
        </section>

      </section>

      {receipt?.transactions?.[0]?.paymentType === "INVOICE" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of via {receipt?.transactions?.[0]?.modeOfPayment}
        </div>
      )}

      {receipt?.transactions?.[0]?.paymentType === "ADVANCE_PAYMENT" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of Advance Receipt
        </div>
      )}

      {receipt?.transactions?.[0]?.paymentType === "SECURITY_DEPOSIT" && (
        <div className="Thanks-text">
          Received with Thanks, an amount of Rs{" "}
          {receipt?.totalAmountPaid?.toFixed(2)}, {receipt?.trustName ? `from ${receipt?.trustName}` : ''} towards Payment of Security Deposit
        </div>
      )}

      <div className="billing-payments-table" style={{ marginBottom: '20px' }}>
        <div className='table-heading'>Payment Details</div>
        <table style={{ paddingTop: '50px' }} className="styled-table-pr" id="tablePreview">
          <thead style={{ backgroundColor: "#E1E3EF" }}>

            <tr>
              <th className='subHeading'>Receipt Id</th>
              <th className='subHeading'>Mode of Payment</th>
              <th className='subHeading'>Transaction Amount</th>
              <th className='subHeading'>Transaction Date & Time</th>
            </tr>
          </thead>


          <tbody>
            <tr>
              <td className='subHeading2'>{receipt?.mocReceiptId}</td>
              <td className='subHeading2'>{receipt?.transactions?.[0]?.modeOfPayment}</td>
              <td className='subHeading2' style={{ textAlign: "left" }}>
                {receipt?.totalAmountPaid?.toFixed(2)}
              </td>
              <td className='subHeading2'>
                {moment(receipt?.receiptDateTime).format(
                  "DD-MM-YYYY"
                )}{" "}
                &nbsp; &nbsp;
                {moment(receipt?.receiptDateTime).format(
                  "h:mm:ss a"
                )}{" "}
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div >
  )
}

export default PrintMinimalistic